/* ------------------------------------------------------------------
   La.Voo.Doo — terms acknowledgement
   Gravitas Digital, 2026-09-12. Split into two moments 2026-09-13.

   DOLLS    Taken on the cart, when someone presses Checkout. Shopify does not
            allow custom content inside checkout on this plan, so the cart is
            the last screen we control.

   DIGITAL  Taken the moment someone adds the Digital Experience to their cart,
            so they agree before buying rather than after. The add is held until
            they do.

   Each agreement is remembered for the browser session and written onto the
   cart, so it lands on the order in the Shopify admin.
------------------------------------------------------------------ */

(function () {
	"use strict";

	var KEY_PHYSICAL = "lvd-terms-dolls";
	var KEY_DIGITAL = "lvd-terms-digital";

	var LvdTermsGate = function () {
		var root = null;
		var config = null;
		var els = {};
		var mode = null;          // "physical" | "digital"
		var proceed = null;       // what to run once they agree
		var lastFocused = null;
		var working = false;

		function init() {
			root = document.querySelector(".js-lvd-tg");

			if (!root) {
				return;
			}

			try {
				config = JSON.parse(root.querySelector(".js-lvd-tg-config").textContent);
			} catch (e) {
				return;
			}

			els = {
				modal: root.querySelector(".js-lvd-tg-modal"),
				heading: root.querySelector(".js-lvd-tg-heading"),
				intro: root.querySelector(".js-lvd-tg-intro"),
				body: root.querySelector(".js-lvd-tg-body"),
				checks: root.querySelector(".js-lvd-tg-checks"),
				agree: root.querySelector(".js-lvd-tg-agree"),
				agreeLabel: root.querySelector(".js-lvd-tg-agree-label"),
				cancel: root.querySelector(".js-lvd-tg-cancel"),
				cancelLabel: root.querySelector(".js-lvd-tg-cancel-label"),
				scrim: root.querySelector(".js-lvd-tg-scrim"),
				hint: root.querySelector(".js-lvd-tg-hint"),
				docPhysical: root.querySelector(".js-lvd-tg-doc-physical"),
				docDigital: root.querySelector(".js-lvd-tg-doc-digital"),
				checksPhysical: root.querySelectorAll(".js-lvd-tg-check-physical"),
				checksDigital: root.querySelectorAll(".js-lvd-tg-check-digital")
			};

			els.agree.addEventListener("click", onAgree);
			els.cancel.addEventListener("click", onCancel);
			els.scrim.addEventListener("click", onCancel);
			els.checks.addEventListener("change", refreshAgreeState);
			document.addEventListener("keydown", onKeydown);

			document.addEventListener("click", onClick, true);
			document.addEventListener("submit", onSubmit, true);
		}

		function agreedAlready(key) {
			try {
				return sessionStorage.getItem(key) === config.version;
			} catch (e) {
				return false;
			}
		}

		function remember(key) {
			try {
				sessionStorage.setItem(key, config.version);
			} catch (e) {
				/* private browsing; the cart attribute is still written */
			}
		}

		/* ---------------- doll disclaimers, at checkout ---------------- */

		function checkoutTrigger(el) {
			if (!el || !el.closest) {
				return null;
			}

			return el.closest('[name="checkout"], [href$="/checkout"]');
		}

		function onClick(event) {
			if (!config.hasPhysical) {
				return;
			}

			var trigger = checkoutTrigger(event.target);

			if (!trigger || agreedAlready(KEY_PHYSICAL)) {
				return;
			}

			event.preventDefault();
			event.stopPropagation();

			proceed = function () {
				var form = trigger.closest ? trigger.closest("form") : null;

				if (trigger.tagName === "A" && trigger.href) {
					window.location.href = trigger.href;
					return;
				}

				if (form) {
					if (trigger.name) {
						var carrier = document.createElement("input");
						carrier.type = "hidden";
						carrier.name = trigger.name;
						carrier.value = trigger.value || "";
						form.appendChild(carrier);
					}

					form.submit();
					return;
				}

				window.location.href = window.Shopify.routes.root + "checkout";
			};

			open("physical");
		}

		/* ---------------- digital terms, at add to cart ---------------- */

		function isDigitalAdd(form) {
			if (!form || !form.action || form.action.indexOf("/cart/add") === -1) {
				return false;
			}

			var id = form.querySelector('[name="id"]');

			return !!id && String(id.value) === String(config.digitalVariantId);
		}

		function onSubmit(event) {
			var form = event.target;

			if (!form) {
				return;
			}

			// Digital Experience being added: agree first, then add.
			if (config.hasDigital && isDigitalAdd(form) && !agreedAlready(KEY_DIGITAL)) {
				event.preventDefault();
				event.stopPropagation();

				proceed = function () {
					form.submit();
				};

				open("digital");
				return;
			}

			// A checkout form submitted directly rather than by its button.
			if (config.hasPhysical && form.action && form.action.indexOf("/checkout") !== -1 && !agreedAlready(KEY_PHYSICAL)) {
				event.preventDefault();
				event.stopPropagation();

				proceed = function () {
					form.submit();
				};

				open("physical");
			}
		}

		/* ---------------- the dialog ---------------- */

		function open(which) {
			mode = which;
			lastFocused = document.activeElement;

			var digital = which === "digital";

			els.heading.textContent = digital ? config.digitalHeading : config.checkoutHeading;
			els.intro.textContent = digital ? config.digitalIntro : config.checkoutIntro;
			els.agreeLabel.textContent = digital ? config.digitalAgree : config.checkoutAgree;
			els.cancelLabel.textContent = digital ? config.digitalCancel : config.checkoutCancel;
			els.hint.textContent = "";

			show(els.docDigital, digital);
			show(els.docPhysical, !digital);
			toggleChecks(els.checksDigital, digital);
			toggleChecks(els.checksPhysical, !digital);

			refreshAgreeState();

			root.classList.add("is-open");
			document.body.style.overflow = "hidden";
			els.body.scrollTop = 0;
			els.modal.focus();

			if (window.themeCore && window.themeCore.utils && window.themeCore.utils.trapFocus) {
				window.themeCore.utils.trapFocus(els.modal);
			}
		}

		function show(el, on) {
			if (el) {
				el.hidden = !on;
			}
		}

		function toggleChecks(nodes, on) {
			Array.prototype.forEach.call(nodes, function (node) {
				node.hidden = !on;

				var input = node.querySelector("input");

				if (input) {
					input.disabled = !on;

					if (!on) {
						input.checked = false;
					}
				}
			});
		}

		function activeInputs() {
			return Array.prototype.filter.call(
				els.checks.querySelectorAll("input[type=checkbox]"),
				function (input) { return !input.disabled; }
			);
		}

		function refreshAgreeState() {
			var inputs = activeInputs();
			var all = inputs.length > 0 && inputs.every(function (i) { return i.checked; });

			els.agree.disabled = !all || working;

			if (all) {
				els.hint.textContent = "";
			}
		}

		function close() {
			root.classList.remove("is-open");
			document.body.style.overflow = "";

			if (window.themeCore && window.themeCore.utils && window.themeCore.utils.removeTrapFocus) {
				window.themeCore.utils.removeTrapFocus();
			}

			if (lastFocused && lastFocused.focus) {
				lastFocused.focus();
			}
		}

		function onCancel(event) {
			if (event) {
				event.preventDefault();
			}

			proceed = null;
			close();
		}

		function onKeydown(event) {
			if (event.key === "Escape" && root.classList.contains("is-open")) {
				onCancel(event);
			}
		}

		function onAgree(event) {
			event.preventDefault();

			var inputs = activeInputs();

			if (!inputs.length || !inputs.every(function (i) { return i.checked; })) {
				els.hint.textContent = config.hintText;
				return;
			}

			working = true;
			els.agree.disabled = true;

			var digital = mode === "digital";
			var attrs = {};

			if (digital) {
				attrs["Digital terms accepted"] = config.digitalLabel;
				attrs["Digital terms accepted at"] = new Date().toISOString();
			} else {
				attrs["Doll disclaimers accepted"] = config.physicalLabel;
				attrs["Doll disclaimers accepted at"] = new Date().toISOString();
			}

			// Separate keys per agreement, so one never overwrites the other on the order.
			fetch(window.Shopify.routes.root + "cart/update.js", {
				method: "POST",
				headers: { "Content-Type": "application/json", Accept: "application/json" },
				body: JSON.stringify({ attributes: attrs })
			})
				.then(done)
				.catch(done);
		}

		/* Whether or not the attribute write succeeded, do not strand the customer.
		   They have ticked the boxes; let them through. */
		function done() {
			working = false;
			remember(mode === "digital" ? KEY_DIGITAL : KEY_PHYSICAL);
			close();

			if (proceed) {
				var go = proceed;
				proceed = null;
				go();
			}
		}

		return Object.freeze({ init: init, open: open, close: close });
	};

	var action = function () {
		window.themeCore = window.themeCore || {};
		window.themeCore.LvdTermsGate = window.themeCore.LvdTermsGate || LvdTermsGate();
		window.themeCore.LvdTermsGate.init();
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", action, { once: true });
	} else {
		action();
	}
})();
